import {makeStyles} from "@material-ui/core";

const styles = (theme) => ({
  subHeader: {
    fontSize: 14,
    fontFamily: 'Roboto-Regular'
  },
  sourceItemCheckBox: {
    display: 'flex',
    alignItems: 'center',
    '& > p': {
      fontFamily: 'Roboto-Bold',
      fontSize: 20,
      margin: 0,
      padding: 0
    },
    marginBottom: 5
  },
  error: {
    color: theme.palette.error.main,
    margin: 0
  },
  link: {
    color: theme.palette.primary.main,
    '&:hover': {
      cursor: 'pointer'
    }
  },
  containerCheckbox: {
    padding:0,
    marginRight: 8,
  },
  containerName: {
    marginLeft: '5px !important'
  },
  loadingContainer: {
    width: '100%',
    minHeight: 300,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
});

export default makeStyles(styles);